/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreContact = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M6.4 6.959a1.419 1.419 0 0 0 2.205.001l1.233-2.261c.106-.195.162-.412.162-.633V2.031C10 .91 8.656.001 7.502.001 6.347.001 5 .91 5 2.031l.003 2.037c0 .22.056.437.162.632l1.234 2.26zM12.37 16H2.63c-.348 0-.63-.247-.63-.553v-3.381c0-.642.238-1.272.671-1.773l1.373-1.594c.2-.233.568-.287.844-.132l1.694.963a1.899 1.899 0 0 0 1.836.001l1.694-.964c.272-.152.631-.102.833.118l1.327 1.45c.47.515.728 1.167.728 1.839v3.473c0 .306-.282.553-.63.553z"
    />
  </svg>
);

IconCoreContact.displayName = 'IconCoreContact';

IconCoreContact.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreContact);
IconCoreContact.displayName = 'IconCoreContact';
